import { apiFetch } from "./client";

export type ErpOutboxStatus = "PENDING" | "SENT" | "FAILED";

// One row carries one document: either the order fields or the contract fields are set, never both.
export type ErpOutboxRow = {
  id: string;
  kind: string;
  orderId: string | null;
  orderNumber: string | null;
  contractId: string | null;
  contractReference: string | null;
  // A customer row has neither an order nor a contract: its document is the company itself.
  companyId: string | null;
  companyName: string | null;
  status: ErpOutboxStatus;
  attempts: number;
  lastError: string | null;
  nextAttemptAt: string;
  createdAt: string;
  sentAt: string | null;
  erpReference: string | null;
};

const q = (params: Record<string, string | undefined>) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v && usp.set(k, v));
  const s = usp.toString();
  return s ? `?${s}` : "";
};

/** Where a customer stands on its way into the ERP; erpCode is set once it is written. */
export type CompanyErpStatus = {
  status: ErpOutboxStatus;
  attempts: number;
  lastError: string | null;
  nextAttemptAt: string;
  sentAt: string | null;
  erpCode: string | null;
};

export const erpApi = {
  list: (status?: ErpOutboxStatus) => apiFetch<ErpOutboxRow[]>(`/admin/erp/outbox${q({ status })}`),
  retry: (id: string) => apiFetch<void>(`/admin/erp/outbox/${id}/retry`, { method: "POST" }),
  /** Undefined when the customer never went to the ERP (204). */
  companyStatus: (companyId: string) =>
    apiFetch<CompanyErpStatus | undefined>(`/admin/companies/${companyId}/erp-status`),
};
